import { createClient } from '@connectrpc/connect';
import { IgniteUserService } from '@wavingroup/iot-core/gen/ts/wavin/ignite/v1/ignite_user_service_pb';
import { igniteTransport } from '~/services/api/service-transport';

export const igniteUserPromiseClient = createClient(
  IgniteUserService,
  igniteTransport,
);
